import React from "react"
import { Drawer, Select, Space } from "antd"
import { Button } from "src/components/actions/button"
import { CloseSvg } from "src/components/Svg"
import { FeedUrlsEditor } from "src/pages-lib/points/feed-urls-editor"
import { useAppData } from "src/store/app-data"

const PLATFORMS = [
  { label: "2ГИС", value: "2gis" },
  { label: "Яндекс", value: "yandex" },
]

/**
 * Ссылки бренда для внешних фидов.
 *
 * Набор общий для всех точек этого типа: точка использует его, пока у неё
 * не задан собственный список.
 */
export function FeedUrlsDrawer({ category, onClose }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)
  const [platform, setPlatform] = React.useState(PLATFORMS[0].value)

  return (
    <Drawer
      width={layoutConfig.isMobile ? "90%" : "50%"}
      title={`Ссылки типа точек: ${category?.title ?? ""}`}
      onClose={onClose}
      open
      extra={
        <Space>
          <Select
            value={platform}
            options={PLATFORMS}
            onChange={setPlatform}
            style={{ width: 140 }}
          />
          <Button type="text" onClick={onClose}>
            <CloseSvg /> Закрыть
          </Button>
        </Space>
      }
    >
      <FeedUrlsEditor
        endpoint={`point-categories/${category?.id}/feed-urls`}
        platform={platform}
        hint="Эти ссылки уходят в фид у всех точек типа, если у самой точки список не задан. Порядок строк — порядок тегов в фиде."
      />
    </Drawer>
  )
}
